import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { RequirementFormPage } from 'src/app/pages/requirement-form/requirement-form.page';
import { UtilsService } from '../utils/utils.service';


@Injectable()
export class RequestCreationGuard implements CanDeactivate<RequirementFormPage> {

  constructor(private utils: UtilsService) { }

  async canDeactivate(component: RequirementFormPage) {
    if (component.canLevaeAfterCreation())
      return true;

    if (component.canLeave()) {
      const answer: Boolean = await this.utils.confirmLeave();
      return !!answer
    }
    return true
  }

}